// Chart.js v2 plugin registration; react-chartjs-2 v2 uses Chart.js v2 under the hood
// Import Chart directly from chart.js v2 to avoid undefined/plugin registration issues.
import Chart from 'chart.js';

// Avoid double-registration in hot reload/dev
if (Chart && Chart.pluginService && !Chart.__gpuDefaultsPluginRegistered) {
Chart.pluginService.register({
	afterDatasetsDraw: function (chart) {
		// Only activate the plugin if it's made available
		// in the options
		if (
			!chart.options.plugins.xLabelsOnTop ||
			(chart.options.plugins.xLabelsOnTop && chart.options.plugins.xLabelsOnTop.active === false)
		) {
			return;
		}

		// To only draw at the end of animation, check for easing === 1
		const ctx = chart.ctx;

		(chart.data.datasets || []).forEach(function (dataset, i) {
			const meta = chart.getDatasetMeta(i);

			if (!meta.hidden) {
				(meta.data || []).forEach(function (element, index) {
					// Draw the text in black, with the specified font
					ctx.fillStyle = 'rgba(255, 255, 255, 0.7)';
					const fontSize = 13;
					const fontStyle = 'normal';
					const fontFamily = 'Muli, Roboto, Helvetica Neue, Arial, sans-serif';
					if (Chart.helpers && Chart.helpers.fontString) {
						ctx.font = Chart.helpers.fontString(fontSize, fontStyle, fontFamily);
					}

					// Just naively convert to string for now
					const value = dataset && dataset.data ? dataset.data[index] : undefined;
					const dataString = typeof value === 'number' || typeof value === 'string' ? String(value) + 'k' : '';
					if (!dataString) {
						return;
					}

					// Make sure alignment settings are correct
					ctx.textAlign = 'center';
					ctx.textBaseline = 'middle';
					const padding = 15;
					const startY = 24;
					const position = element.tooltipPosition();
					ctx.fillText(dataString, position.x, startY);

					ctx.save();

					ctx.beginPath();
					ctx.setLineDash([5, 3]);
					ctx.moveTo(position.x, startY + padding);
					ctx.lineTo(position.x, position.y - padding);
					ctx.strokeStyle = 'rgba(255,255,255,0.54)';
					ctx.stroke();

					ctx.restore();
				});
			}
		});
	}
});
Chart.__gpuDefaultsPluginRegistered = true;
}
